module.exports = __webpack_public_path__ + "static/media/half-logo.288c279e.svg";